import { render, staticRenderFns } from "./conferencia.vue?vue&type=template&id=2437e379&"
import script from "./conferencia.vue?vue&type=script&lang=js&"
export * from "./conferencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports